// ProtectedRoute.js - Route protection component for Travel+ CRM
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { user, loading, isAuthenticated } = useAuth();

  // Independent agents have 'type' instead of 'role'
  const userRole = user?.role || user?.type;

  console.log('ProtectedRoute check:', { 
    user: user ? { id: user.id, role: user.role, type: user.type, userRole, name: user.name } : null, 
    loading, 
    isAuthenticated, 
    allowedRoles,
    currentPath: window.location.pathname,
    roleCheck: allowedRoles.length > 0 ? `User role '${userRole}' in allowed roles [${allowedRoles.join(', ')}]? ${allowedRoles.includes(userRole)}` : 'No role restriction'
  });

  if (loading) {
    console.log('ProtectedRoute: Still loading, showing spinner');
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    console.log('ProtectedRoute: User not authenticated, redirecting...');
    // Redirect to appropriate login page based on the requested route
    const currentPath = window.location.pathname;
    
    if (currentPath.startsWith('/admin')) {
      return <Navigate to="/admin/login" replace />;
    } else if (currentPath.startsWith('/independent')) {
      return <Navigate to="/independent" replace />;
    } else if (currentPath.startsWith('/agency')) {
      return <Navigate to="/" replace />;
    } else {
      return <Navigate to="/" replace />;
    }
  }

  // Check for commission_only agents and redirect to commission-only page
  const currentPath = window.location.pathname;
  if (userRole === 'agent' && user.status === 'commission_only') {
    // Allow access to commission-only page and profile
    if (!currentPath.includes('/agent/commissions-only') && !currentPath.includes('/agent/profile')) {
      console.log('ProtectedRoute: Commission-only agent, redirecting to commissions-only page');
      return <Navigate to="/agent/commissions-only" replace />;
    }
  }

  // Check role-based access
  if (allowedRoles.length > 0 && !allowedRoles.includes(userRole)) {
    console.log('ProtectedRoute: User role not allowed, redirecting to appropriate dashboard');
    // Redirect to appropriate dashboard based on user role
    switch (userRole) {
      case 'super_admin':
        return <Navigate to="/admin/dashboard" replace />;
      case 'agency_admin':
        // Redirect agency admins to /admin/dashboard (not legacy /agency/dashboard)
        return <Navigate to="/admin/dashboard" replace />;
      case 'agent':
        return <Navigate to="/agent/dashboard" replace />;
      case 'independent_agent':
        return <Navigate to="/independent/dashboard" replace />;
      default:
        return <Navigate to="/" replace />;
    }
  }

  console.log('ProtectedRoute: Access granted, rendering children');
  return children;
};

export default ProtectedRoute;
